import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { HearingLossService } from '../../../services/index';

@Component({
	selector: 'add-edit-hearing-loss-window',
	templateUrl: './addEditHearingloss.component.html'
})
export class AddEditHearinglossComponent implements OnInit {
	public title: string;
	public mode: string;
	public list: any[] = [];
	public hearinglossdata: any[] = [];

	// trigger-variable for Ladda
	isLoading: boolean = false;

	@Output() hearingLossLoadEvent = new EventEmitter();

	constructor(private hearinglossService: HearingLossService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

	}

	ngOnInit(): void {
		setTimeout(() => {
            $('#loss_name').focus();
        }, 100);
	}

	onSaveHearingloss(): void {
		let that = this;
		this.isLoading = true;
		this.hearinglossService
			.addUpdateHearingloss(this.hearinglossdata)
			.then(function(res: any) {
				that.isLoading = false;
				if (res.success){
					swal('SUCCESS', res.message, 'success');
					that.bsModalRef.hide();
					that.hearingLossLoadEvent.emit();
				}else{
					var toast = {
				      type: 'error',
				      title: 'ERROR',
				      body: res.message
				    };
				    that.toasterService.pop(toast);
				}
			});
	}
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/hearingLoss/addEditHearingloss.component.ts